<template>
  <section class="work">
    <heading :ahead="title.ahead" :behind="title.behind" />
    <experience :info="info" :detail="detail" />
    <!-- <experience :info="info" :detail="detail" dir="rtl" /> -->
  </section>
</template>

<script>
import Heading from "../components/Heading.vue";
import Experience from "../components/Experience.vue";

export default {
  name: "Work",
  components: {
    Heading,
    Experience
  },
  data() {
    return {
      title: {
        ahead: "Work",
        behind: "Experience"
      },
      info: {
        image: "logos/nakisa.jpg",
        duration: "June 2019 - Present",
        job: "Software Developer"
      },
      detail: {
        company: "Nakisa Inc",
        tasks: [
          "Worked on multiple projects starting with requirements gathering, designing, developing, refactoring, and code implementation",
          "Implemented the redesigned user dashboard with better UX and performance",
          "Refactored existing code to improve performance and the removal of redundant code",
          "Introduced State management i.e. VUEX in the existing project",
          "Introduces team-level standards and best coding practices guidelines",
          "Created documentation of the major features of application for testing and integration",
          "Improved existing layout, applied UX/UI principles to improve overall application design",
          "Implemented OAuth2 authentication in all resource projects",
          "Developed Api endpoints to serve data to client applications"
        ]
      }
    };
  }
};
</script>

<style scoped>
.work {
  padding: 1em;
  margin: 15px 0px;
}

.work::before {
  position: absolute;
  content: "";
  background: #f7f7f7;
  width: 65vw;
  height: 25vh;
  right: 0px;
  z-index: -10;
  transform: translateY(150%);
}
</style>
